import { get } from '@eika-infrastruktur/request';

import type { LastLogin } from '../generated-types';
import { CONTEXT_PATH } from './index';

const SERVICE_PATH = 'rest/resource/lastlogin';

const getLastLogin = async (): Promise<LastLogin | undefined> => {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}`);
};

export default getLastLogin;
